var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-drawer-app-content flex-auto overflow-auto relative",attrs:{"id":"app-content"}},[_c('Header'),_c('Main',{attrs:{"mainImg":_vm.mainImg}}),_c('SignatureCollection'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }